var PROJECT = window.COTACAO = window.COTACAO || {};
if(document.getElementById('cotacao-appviewbox')){
    (function (scope) {
        'use strict';
        var app = document.getElementById('cotacao-appviewbox');
        
        var site = app.getAttribute('data-base');
        var assets = app.getAttribute('data-assets');
        var base = site.split(location.host).pop();
        scope.config = {
            urls: {
                base: base,
                assets: assets,
                script: base,
                site: site,
                origin: location.protocol + '//' + location.hostname
            }
        };
    }(COTACAO));

    var scope = require('scope');
    scope.$ = require('jquery');
    scope.regionsData = {};

    scope.setvars = function(vars){
        scope.vars = vars;
    }

    scope.app = require('app');
    scope.app.on('start', require('./views/init'));
    scope.app.on('start', require('./routes/init'));
    scope.metrics = require('./lib/metrics');
    scope.app.start();
}


// WEBPACK FOOTER //
// ./resources/scripts/main.js